var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"admin-menu"},_vm._l((_vm.menus.childrens),function(item){return _c('menuItem',{key:item.sid,attrs:{"menu":item},on:{"click":_vm.menuClick}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }